module.exports = __webpack_public_path__ + "img/andere.f8a6faee.png";